import { number, object, string } from 'yup';

/**
 * Regex to accept most city/state names worldwide.
 * - A through Z and U+00C0 through U+024F which includes most viable characters for city/state names
 * - A period followed by a space ". " for names like St. Paul
 * - Hyphens
 * - Single spaces
 * - Single quotes
 * - And must end with A through Z or one of the valid higher unicode characters.
 *
 * Adapted from https://stackoverflow.com/a/19574997
 */
const nonNumericCharacterString = /^(?:[a-zA-Z\u00C0-\u024F]+(?:. |-| |'))*[a-zA-Z\u00C0-\u024F]*$/;

export const addressSchema = object({
  street: string().trim().required('address.street.required'),
  street2: string().trim().notRequired().nullable(),
  city: string()
    .trim()
    .matches(nonNumericCharacterString, 'address.city.invalidChars')
    .required('address.city.required'),
  country: string().notRequired(),
  lat: number().notRequired().nullable(),
  long: number().notRequired().nullable(),
  province: string()
    .trim()
    .matches(nonNumericCharacterString, 'address.state.invalidChars')
    .required('address.state.required'),
  zipCode: string()
    .trim()
    .matches(/^\d{5}(?:-\d{4})?$/, 'address.zipCode.invalidFormat')
    .required('address.zipCode.required'),
});
